import { Injectable, OnDestroy } from '@angular/core';
import { GridActionsService } from './grid-actions.service';
import { GridApi, GridOptions, IFilter } from '@ag-grid-community/core';
import { GridApiService } from './grid-api.service';
import { LoadingCellRendererComponent } from '../ag-grid-components/loading-cell-renderer/loading-cell-renderer.component';
import { StatusBarRendererComponent } from '../ag-grid-components/status-bar-renderer/status-bar-renderer.component';
import { CustomHeaderTooltipComponent } from '../ag-grid-components/custom-header-tooltip/custom-header-tooltip.component';
import { AvalableDateLabels, DatePickerModel } from '../components/date-picker-dialog/date-picker.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsPlGridConfigService implements OnDestroy {
  gridApi: GridApi
  isGridReady: boolean = false;
  dateFilter: DatePickerModel = {
    from: new Date(new Date().setDate(new Date().getDate() - 30)),
    to: new Date(),
    label: AvalableDateLabels.Last30Days,
  };
  firstRender: boolean;
  private destroy$ = new Subject<void>();
  
  constructor(private gridActionsService: GridActionsService,
    private gridApiService: GridApiService) { }
    
  components = {
    statusBarRendererComponent: StatusBarRendererComponent,
    loadingCellRenderer: LoadingCellRendererComponent,
    customHeaderTooltipComponent: CustomHeaderTooltipComponent,
  };

  gridOptions: GridOptions = {
    rowModelType: "serverSide",
    blockLoadDebounceMillis: 1,
    suppressServerSideInfiniteScroll: false,
    suppressCopyRowsToClipboard: true,
    suppressCellFocus : true,
    defaultColDef: {
      flex: 1,
      resizable: true,
      sortable:false,
      filterParams: {
        maxNumConditions : 1,
      },
      menuTabs: ["filterMenuTab"],
      tooltipComponent: "customHeaderTooltipComponent",
    },
    components: this.components,
    rowHeight: 42,
    headerHeight: 50,                   
    loadingCellRenderer: "loadingCellRenderer",
    statusBar: {
      statusPanels: [
        { statusPanel: "statusBarRendererComponent", align: "left" },
      ],
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
   },
    cacheBlockSize: 100,
    pivotPanelShow: "onlyWhenPivoting",
    rowBuffer: 50,
    enableCellChangeFlash: true,
    suppressMenuHide: true,
    icons: {
      menu: '<span class="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>',
      filter:
        '<span class="ag-icon ag-icon-filter" style="display:none;" unselectable="on" role="presentation"></span>',
    },
    onGridReady: (e) => {
      this.gridApi = e.api;
      this.gridApiService.gridApi$.next(e);
      this.gridActionsService.applycolumnState(e);
      this.gridApi?.sizeColumnsToFit();
    },
    onColumnVisible: (e) => this.gridActionsService.columnVisible(e,this.isGridReady),
    onColumnPinned: () => this.gridActionsService.saveColumnState(null,this.isGridReady),
    onDragStopped: () => this.gridActionsService.saveColumnState(null,this.isGridReady),
    onRowSelected: () => this.gridActionsService.updateSelectedRows(),
    onCellKeyDown: (e) => this.gridActionsService.onCellKeyDown(e),
    onFirstDataRendered:() => this.isGridReady = true,
    onModelUpdated: (e) => {
      if (this.firstRender && e.api.getDisplayedRowCount() > 1) {
        this.gridApi?.sizeColumnsToFit();
        this.firstRender = false;
      }
    },
  };

  setDateFilter(e: DatePickerModel) {
    this.dateFilter = e;
    if (this.gridApi) {
      const filterInstance: IFilter = this.gridApi.getFilterInstance("Date");
      filterInstance.setModel({
        filterType: "date",
        type: "inRange",
        dateFrom:  new Date(this.dateFilter.from.getTime() - (this.dateFilter.from.getTimezoneOffset() * 60000)).toISOString(),
        dateTo: new Date(this.dateFilter.to.getTime() - (this.dateFilter.to.getTimezoneOffset() * 60000)).toISOString(),
      });
      this.gridApi.onFilterChanged();
    }
  }

  setPlDateRange(viewByPlValue){
    switch (viewByPlValue) {
      case 'month':          
      this.dateFilter.from = new Date(new Date().setDate(new Date().getDate() - 365));
      this.dateFilter.to = new Date()
      break;            
      case 'quarter':
        this.dateFilter.from = new Date(new Date().setDate(new Date().getDate() - 365));
       this.dateFilter.to = new Date()
      break;
      case 'week': 
      this.dateFilter.from = new Date(new Date().setDate(new Date().getDate() - 84));
       this.dateFilter.to = new Date()
      break;
      case 'year':  
      this.dateFilter.from = new Date(new Date().setDate(new Date().getDate() - 730));
       this.dateFilter.to = new Date()        
      break
      case 'settlement':  
      this.dateFilter.from = new Date(new Date().setDate(new Date().getDate() - 84));
       this.dateFilter.to = new Date()
      break
      } 
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}